module.exports = __webpack_public_path__ + "static/img/share.8269620.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/share.png
// module id = fsxF
// module chunks = 6